<template>
    <span class="ui-social" :class="classes">
        <component :is="'icon-' + type"></component>
    </span>
</template>

<script>
export default {
    name: 'ui-social',
    props: {
        type: {
            type: String,
            required: true
        }
    },
    computed: {
        classes () {
            return {
                [`ui-social--${this.type}`]: this.type
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
    .ui-social {
        color #fff
        display flex
        align-items center
        justify-content center
        cursor pointer
    }
</style>
